import React from 'react';

import { tracking } from '@iwoca/frontend-tracking-library';
import _ from 'lodash';
import { FormGroup, Col } from 'react-bootstrap';
import { FormattedMessage } from 'react-intl';

import messages from './Address.messages';
import CountrySelect from './CountrySelect';
import styles from './ManualAddress.module.css';
import FormField from '../../components/FormField';
import { nonAlphaSpaces } from '../../helpers/helpers';
import normalizer from '../../helpers/inputNormalizer';
import InternalLink from '../InternalLink';

class ManualAddress extends React.Component {
    componentDidMount() {
        const {
            field: { auto },
            field,
            manualAddressState
        } = this.props;
        this._cachedValues = _.reduce(
            field,
            (memo, item) => {
                memo[item.name] = item.value;
                return memo;
            },
            {}
        );
        auto.onChange(!manualAddressState);
    }

    blurDecorator = (fn, fieldName) => {
        const cachedValues = this._cachedValues;
        const { field } = this.props;

        return function (val) {
            if (field.equifax_token.value && cachedValues[fieldName] !== val) {
                field.equifax_token.onChange('');
            }

            if (val.length > 0) {
                tracking.ampli.formFieldCompleted({
                    form_field: fieldName
                });
            }

            fn.call(this, val);
        };
    };

    onCountrySelect = (country) => {
        tracking.ampli.formFieldCompleted({
            form_field: 'manual_address_country'
        });
        this.props.onCountrySelect(country);
    };

    render() {
        const { onManualAddress, addressIndex, personUID, field } = this.props;
        const maskedPostCode = normalizer(field.postcode, nonAlphaSpaces, null);
        return (
            <FormGroup className="sub-form-group" key={addressIndex}>
                <div className="fields-holder">
                    <FormField
                        data-dd-privacy="mask"
                        wrapperClassName="col-left fs-exclude"
                        field={field.street_line_1}
                        label="Address line 1">
                        <FormField.Input
                            whenBlur={(event) => {
                                if (event?.target?.value?.length > 0) {
                                    tracking.ampli.formFieldCompleted({
                                        form_field: 'manual_address_line_1'
                                    });
                                }
                            }}
                            maxLength={200}
                            onBlur={this.blurDecorator(
                                field.street_line_1.onBlur,
                                field.street_line_1.name
                            )}
                        />
                    </FormField>
                    <FormField
                        data-dd-privacy="mask"
                        wrapperClassName="col-right fs-exclude"
                        field={field.street_line_2}
                        label="Address line 2">
                        <FormField.Input
                            whenBlur={(event) => {
                                if (event?.target?.value?.length > 0) {
                                    tracking.ampli.formFieldCompleted({
                                        form_field: 'manual_address_line_2'
                                    });
                                }
                            }}
                            maxLength={200}
                            onBlur={this.blurDecorator(
                                field.street_line_2.onBlur,
                                field.street_line_2.name
                            )}
                        />
                    </FormField>
                </div>
                <div className="fields-holder">
                    <FormField
                        data-dd-privacy="mask"
                        wrapperClassName="col-left fs-exclude"
                        field={field.town}
                        label="Town / city">
                        <FormField.Input
                            whenBlur={(event) => {
                                if (event?.target?.value?.length > 0) {
                                    tracking.ampli.formFieldCompleted({
                                        form_field: 'manual_address_town'
                                    });
                                }
                            }}
                            maxLength={200}
                            onBlur={this.blurDecorator(
                                field.town.onBlur,
                                field.town.name
                            )}
                        />
                    </FormField>
                    <FormField
                        data-dd-privacy="mask"
                        wrapperClassName="col-right fs-exclude"
                        field={field.postcode}
                        label="Postcode">
                        <FormField.Input
                            whenBlur={(event) => {
                                if (event?.target?.value?.length > 0) {
                                    tracking.ampli.formFieldCompleted({
                                        form_field: 'manual_address_postcode'
                                    });
                                }
                            }}
                            maxLength={200}
                            onBlur={this.blurDecorator(
                                maskedPostCode.onBlur,
                                maskedPostCode.name
                            )}
                        />
                    </FormField>
                </div>
                <div className="fields-holder">
                    <FormField
                        data-dd-privacy="mask"
                        wrapperClassName="col-left fs-exclude"
                        grid={{ xs: 12, sm: 12 }}
                        label="Country"
                        field={field.country}>
                        <CountrySelect
                            countryField={field.country}
                            onCountrySelect={this.onCountrySelect}
                        />
                    </FormField>
                </div>
                <Col xs={12}>
                    <div className="toggle-role">
                        <InternalLink
                            onClick={onManualAddress.bind(
                                null,
                                personUID,
                                addressIndex
                            )}>
                            <span className={styles.toggleAddressAutomatic}>
                                <FormattedMessage
                                    {...messages.searchForAddressLink}
                                />
                            </span>
                        </InternalLink>
                    </div>
                </Col>
            </FormGroup>
        );
    }
}

export default ManualAddress;
